
export enum EngineListActions {
	DELETE_SELECTED = 'DELETE_SELECTED'
}

export enum EngineRulesListActions {
	ACTIVATE_SELECTED = 'ACTIVATE_SELECTED',
	DEACTIVATE_SELECTED = 'DEACTIVATE_SELECTED',
	DELETE_SELECTED = 'DELETE_SELECTED',
}

export enum GroupsListActions {
	DELETE_SELECTED = 'DELETE_SELECTED'
}

export enum GroupsRulesListActions {
	ACTIVATE_SELECTED = 'ACTIVATE_SELECTED',
	DEACTIVATE_SELECTED = 'DEACTIVATE_SELECTED',
	DELETE_SELECTED = 'DELETE_SELECTED',
}

export enum RulesListActions {
	ACTIVATE_SELECTED = 'ACTIVATE_SELECTED',
	DEACTIVATE_SELECTED = 'DEACTIVATE_SELECTED',
	DELETE_SELECTED = 'DELETE_SELECTED',
}

export enum ChannelingDashboardActions {
	CHANNELING_RULES,
	CHANNELING_GROUPS,
}

export enum GroupRulesAssociateListActions {
}

export enum GroupUsersSelectedTypes {
	GREEN_TYPE,
	YELLOW_TYPE,
	RED_TYPE
}

export enum GroupUsersStatus {
	STATUS_OK = 'OK',
	STATUS_DELETED = 'DELETED',
	STATUS_PERMISSIONS_REVOKED = 'PERMISSION_REVOKED'
}

export enum DashboardValuesMap {
	VALUE_GROUPS = 'groups',
	VALUE_RULES = 'rules'
}

export enum UserListActions {
	ACTIVATE_SELECTED = 'ACTIVATE_SELECTED',
	DEACTIVATE_SELECTED = 'DEACTIVATE_SELECTED',
}

export enum FlottaPoolActions {
	ASSIGN = 'ASSIGN',
	TO_EVALUATE = 'TO_EVALUATE',
	DELETE = 'DELETE'
}

export enum FlottaPoolActivateActions {
	TRANSFER = 'TRANSFER',
	CHANGE_ASSIGN = 'CHANGE_ASSIGN',
	ASSIGN_CLUSTER = 'ASSIGN_CLUSTER',
	ACTIVATE = 'ACTIVE',
	SUSPEND = 'SUSPEND',
	CLOSE = 'CLOSE',
	DELETE = 'DELETE'
}

export enum FlottaPoolClusterActivateActions {
	DELETE = 'DELETE'
}

export enum FlottaPoolClusterTypeActivateActions {
	DELETE = 'DELETE'
}
